import { ComponentPropsWithoutRef, MouseEvent } from 'react';

import classNames from 'classnames';

import { ExternalLink } from '@uikit';

import { DeserializedTokenData } from '@api';

import { useAuth } from '@shared/common/providers/AuthProvider';
import { useAuthModal } from '@shared/common/providers/GlobalModalsProvider';
import useGetSwapperTerms from '@shared/hooks/useGetSwapperTerms';

interface AppTokenSwapButtonProps extends ComponentPropsWithoutRef<'a'> {
  token?: DeserializedTokenData;
}

const AppTokenSwapButton = ({ token, className }: AppTokenSwapButtonProps) => {
  const { isAuth } = useAuth();
  const loginModal = useAuthModal();
  const { canSwap, chainId, address } = token?.attributes || {};
  const swapLink = `${process.env.NEXT_PUBLIC_SWAP_HOST}?network=${chainId}&token=${address}`;
  const { showSwapperLinks } = useGetSwapperTerms();

  if (!showSwapperLinks || !canSwap) {
    return null;
  }

  const handleSwapLink = (e: MouseEvent<HTMLAnchorElement>) => {
    if (!isAuth) {
      loginModal.open();
      e.preventDefault();
    }
  };

  return (
    <ExternalLink
      href={swapLink}
      onClick={handleSwapLink}
      className={classNames(
        'button button-outline-primary p-0 min-w-[82px] w-fit text-[14px] min-h-[24px] leading-3',
        className,
      )}
    >
      Swap
    </ExternalLink>
  );
};

export default AppTokenSwapButton;
